import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {NgTemplateOutlet} from '@angular/common';
import {s3TagValueLengthValidator} from '../../name-limits';


import {countInvalidFields} from '../form-messages';
@Component({
  selector: 'app-basic-poitem-vod-info',
  templateUrl: './basic-poitem-vod-info.component.html',
  styleUrls: ['./basic-poitem-vod-info.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => BasicPoitemVodInfoComponent),
  },
    {
      provide: NG_VALIDATORS,
      useExisting: BasicPoitemVodInfoComponent,
      multi: true
    }],
  imports: [
    ReactiveFormsModule,
    RouterModule,
    NgTemplateOutlet
]
})
export class BasicPoitemVodInfoComponent implements OnInit, ControlValueAccessor {
  @Input() poItemIdLabel = 'Encode ID';
  @Input() poItemIdHelp = '';
  /**
   * 'section' renders the fields under an h3 instead of in a card of their own, for a form whose PO
   * item is already a card (cards don't nest). The repackaging and interactive forms keep 'card'.
   */
  @Input() layout: 'card' | 'section' = 'card';
  /** Set by the PO form once a submit was tried: from then on every field shows its error. */
  @Input() submitted = false;

  /** Prefix of the field ids, unique per form and item; empty keeps the plain ids. */
  @Input() idPrefix = '';


  /** Whether a control shows its error: invalid, and touched/edited or after a refused submit. */
  showInvalid(name: string): boolean {
    const c = this.form?.controls[name];
    return !!c && c.invalid && (c.touched || c.dirty || this.submitted);
  }

  static DEFAULTS = {
    input_brefix: '',
    po_item_id: '',
  };
  form: FormGroup;


  private changed;
  private touched;

  constructor(private formBuilder: FormBuilder) {
  }


  writeValue(value) {
    this.form.patchValue(value, {emitEvent: false})
  }

  registerOnChange(fn) {
    this.changed = fn;
  }

  registerOnTouched(fn) {
    this.touched = fn;
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      input_brefix: ['', [Validators.required]],
      // Publish writes the title, custom_quote-encoded, into an S3 object tag.
      po_item_id: ['', [Validators.required, s3TagValueLengthValidator()]],
    })
    this.form.valueChanges.subscribe((val) => {
      this.touched();
      this.changed(val)
    });

  }

  validate({value}: FormControl) {
    const isNotValid = !this.form.valid
    return isNotValid && {
      invalid: true,
      invalidFields: countInvalidFields(this.form),
    }
  }

}
